import { render, staticRenderFns } from "./serveComment.vue?vue&type=template&id=10ef09da&"
import script from "./serveComment.vue?vue&type=script&lang=ts&"
export * from "./serveComment.vue?vue&type=script&lang=ts&"
import style0 from "./serveComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports